// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-4{font-weight:400;font-size:3.5rem;line-height:1.2}@media(max-width: 1200px){.display-4{font-size:calc(1.475rem + 2.7vw)}}`, "",{"version":3,"sources":["webpack://./client/styles/display.scss"],"names":[],"mappings":"AAEA,WACE,eAAA,CACA,gBAAA,CACA,eAAA,CAEA,0BALF,WAMI,gCAAA,CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
